import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Status never relies on colour alone — every chip carries its own label text.
const TONES = {
	default: { bg: '#f5f5f5', border: '#d9d9d9', color: '#595959' },
	success: { bg: '#e5f4ea', border: '#b7e0c6', color: '#267003' },
	warning: { bg: '#fbf0dd', border: '#f0d9a8', color: '#8a5000' },
	danger: { bg: '#fbe9e7', border: '#f5c6c2', color: '#B11500' },
	primary: { bg: '#F6FDFF', border: '#a8cfe0', color: '#18405d' },
};

const Chip = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 1px 8px;
	border-radius: 10px;
	border: 1px solid ${(props) => TONES[props.tone].border};
	background: ${(props) => TONES[props.tone].bg};
	color: ${(props) => TONES[props.tone].color};
	font-size: 11px;
	font-weight: 500;
	line-height: 18px;
	white-space: nowrap;
`;

export default function StatusChip({ label, tone, className }) {
	return (
		<Chip tone={tone} className={className}>
			{label}
		</Chip>
	);
}

StatusChip.propTypes = {
	label: PropTypes.node.isRequired,
	tone: PropTypes.oneOf(['default', 'success', 'warning', 'danger', 'primary']),
	className: PropTypes.string,
};

StatusChip.defaultProps = {
	tone: 'default',
	className: undefined,
};
